import React, {useState, useEffect} from 'react'
import { connect, useDispatch } from 'react-redux';
import {Spinner, Button} from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import {
    getProvidersTypesAction,
    startLoader,
    createProviderTypeAction,
    ProviderTypeFileUploadAction,
    deleteDataAction,
    updateProviderTypeAction,
    downloadProviderTypeTemplateAction
} from '../../../../store/actions/ProviderActions';
import swal from 'sweetalert';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Button as PButton } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataTableBase } from '../../DataTables/DataTableBase';
import { currentUser } from "../../../../store/selectors/CurrentUserSelector";
import { useTranslation } from "react-i18next";
import './ProviderType.css';

const ProviderType = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let errorsObj = { name: '', code: '' };
    const [nameFr, setNameFr] = useState('');
    const [nameEn, setNameEn] = useState('');
    const [file, setFile] = useState(null);
    const [code, setCode] = useState('');
    const [providerTypeId, setProviderTypeId] = useState('');
    const [errors, setErrors] = useState(errorsObj);
    const [templateUrl, setTemplateUrl] = useState('/templates/provider_types_template.csv');
    
    //Modal box
    const [addCard, setAddCard] = useState(false);
    const [updateMode, setUpdateMode] = useState(false);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            nameFr: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalFilterValue("");
    };

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center">
                <PButton 
                    type="button" 
                    icon="pi pi-filter-slash"  
                    label={t('common.reinit')} 
                    outlined 
                    onClick={clearFilter}
                    className="me-2"
                    size="small"
                />
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText 
                        value={globalFilterValue} 
                        onChange={(e) => onGlobalFilterChange(e)} 
                        placeholder={t('common.search')}
                        size="small"
                    />
                </div>
            </div>
        );
    };

    const clearFilter = () => {
        initFilters();
    };

    const setColumns = () => {
        return [
            {name: 'code', headerName: "Code", filterPlaceholder: t("provider.code-filter"), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'nameFr', headerName: t('common.name'), filterPlaceholder: t('common.filter-name'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'createdAt', filterField: 'createdAt', dataType: 'date', headerName:t("patient.created-on"), filterPlaceholder: t('facturation.create-date-filter'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: datePaiementBodyTemplate, filterElement: dateFilterTemplate},
            {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
        ]
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const getActionsTemplate = (rowData) => {
        return <div className="d-flex justify-content-center gap-1">
            {hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'UPDATEPROVIDERTYPE') && 
                <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={(e) => updateData(rowData)}
                    title={t('common.edit')}
                >
                    <i className="fa fa-pencil"></i>
                </button>
            }
            {hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'DELETEPROVIDERTYPE') && 
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDelete(rowData)}
                    title={t('common.delete')}
                >
                    <i className="fa fa-trash"></i>
                </button>
            }
        </div>
    }

    const handleDelete = (rowData) => {
        swal({
            title: t("provider.delete-provider") + rowData.nameFr + " ?",
            text: t("patient.delete-provider-mes"),
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                let data = {
                    type: "TYPEPRESTATAIRE",
                    id: rowData.id
                };
                dispatch(startLoader());
                dispatch(deleteDataAction(data));
            }
        });
    };

    const updateData = (data) => {
        setNameEn(data.nameEn);
        setNameFr(data.nameFr);
        setCode(data.code);
        setProviderTypeId(data.id);
        setAddCard(true);
        setUpdateMode(true);
    }

    const dateFilterTemplate = (options) => {
        return <Calendar 
            value={options.value} 
            onChange={(e) => options.filterCallback(e.value, options.index)} 
            dateFormat="dd/mm/yy" 
            placeholder="dd/mm/yyyy" 
            mask="99/99/9999" 
        />;
    };

    const datePaiementBodyTemplate = (rowData) => {
        return formatDate(rowData.createdAt);
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

const handleDownloadTemplate = () => {
    dispatch(downloadProviderTypeTemplateAction());
};

    const resetForm = () => {
        setNameEn("");
        setNameFr("");
        setCode("");
        setProviderTypeId("");
        setFile(null);
        setErrors(errorsObj);
        setUpdateMode(false);
    };

    useEffect(() => {
        dispatch(startLoader());
        initFilters();
        dispatch(getProvidersTypesAction());    
    }, []);


    useEffect(() => {
        setNameEn("");
        setNameFr("");
        setCode("");
        setProviderTypeId("");
        setUpdateMode(false);
        setAddCard(false);
    }, [props.providerTypes]);


    function onProviderTypeSave(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if(file){
            dispatch(startLoader());
            dispatch(ProviderTypeFileUploadAction(file));
            return;
        }
        // if (code === '') {
        //     errorObj.code = t('common.code-required');
        //     error = true;
        // }
        if (nameFr === '') {
            errorObj.name = t('common.name-required');
            error = true;
        }
        setErrors(errorObj);
        if (error) {
            swal('Oops', t('common.check-form-fields'), "error");
            return;
        }
        dispatch(startLoader());

        if(updateMode) {
            let obj = { nameFr: nameFr, nameEn: nameFr, code: code };
            dispatch(updateProviderTypeAction(providerTypeId, obj));
        } else {
            let obj = { nameFr: nameFr, nameEn: nameFr, code: code };
            dispatch(createProviderTypeAction(obj));
        }
    }
    
    function selectFile(event) {
        setFile(event.target.files[0]);
    }

    return (
        <>
            {/* Header */}
            <div className="provider-type-header  mb-0 form-head bg-white p-3 bt-5 border-top-solid">
                <div>
                    <h4 className="mb-1">{t("provider.type")}</h4>
                    <p className="text-muted mb-0 small">{t("common.manage-provider-types")}</p>
                </div>
                <div className="d-flex gap-2">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handleDownloadTemplate}
                    >
                        <i className="fa fa-download me-1"></i> {t("common.download-template")}
                    </button>
                    
                    {hasMenu('MENPARAMACTES') && canDo('MENPARAMACTES', 'CREATEPROVIDERTYE') && (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                resetForm();
                                setAddCard(true);
                            }}
                        >
                            <i className="fa fa-plus-circle me-1"></i> {t("common.new-typ-prov")}
                        </button>
                    )}
                </div>
            </div>
            
            {/* Modal for creating/editing provider types */}
            <Modal 
                show={addCard} 
                onHide={() => setAddCard(false)}
                centered
                backdrop="static"
            >
                <Modal.Header closeButton className="border-bottom">
                    <Modal.Title className="h5">
                        {updateMode ? t("common.edit-provider-type") : t("common.creat-typ-prov")}
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body className="p-4">
                    <form>
                        <div className="mb-3">
                            <label className="form-label">{t('common.code')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.code ? 'is-invalid' : ''}`}
                                placeholder="PH"
                                value={code}
                                disabled={props.showLoading || file}
                                onChange={(e) => setCode(e.target.value)}
                            />
                            {errors.code && <div className="invalid-feedback">{errors.code}</div>}
                        </div>
                        
                        <div className="mb-3">
                            <label className="form-label">{t('common.label')}</label>
                            <input
                                type="text"
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                placeholder={t('layout.pharmacy')}
                                value={nameFr}
                                disabled={props.showLoading || file}
                                onChange={(e) => setNameFr(e.target.value)}
                            />
                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                        </div>
                        
                        <hr className="my-4" />
                        
                        <div className="mb-3">
                            <h6 className="text-primary mb-3">{t("common.import-csv-prov")}</h6>
                            <div className="input-group">
                                <span className="input-group-text">CSV</span>
                                <input 
                                    type="file" 
                                    className="form-control" 
                                    onChange={selectFile}
                                    accept=".csv"
                                />
                            </div>
                            {file && (
                                <div className="alert alert-info mt-2 py-2">
                                    <small>File selected: <strong>{file.name}</strong></small>
                                </div>
                            )}
                        </div>
                    </form>
                </Modal.Body>
                
                <Modal.Footer className="border-top">
                    <button 
                        type="button" 
                        className="btn btn-outline-secondary"
                        onClick={() => setAddCard(false)}
                        disabled={props.showLoading}
                    >
                        {t('common.cancel')}
                    </button>
                    
                    {props.showLoading ? (
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            <span className="ms-2">{t('common.saving')}</span>
                        </Button>
                    ) : (
                        <button 
                            type="button" 
                            className="btn btn-primary"
                            onClick={onProviderTypeSave}
                        >
                            {t('common.save')}
                        </button>
                    )}
                </Modal.Footer>
            </Modal>
            
            {/* DataTable */}
            <div className="card border-0 shadow-sm bg-white">
                <div className="card-body p-0">
                    <DataTableBase 
                        data={props.providerTypes.length > 0 ? props.providerTypes.map(acte => {
                                acte.createdAt = new Date(acte.createdAt);
                                return acte;
                        }) : []}
                        emptyMessage={t("common.no-prov")}
                        filters={filters}
                        globalFiltersFields={['code', 'nameFr', 'createdAt']}
                        header={renderHeader()}
                        columns={setColumns()}
                        exportColumns={[
                            { title: 'Code', dataKey: 'code' },
                            { title: t('common.name'), dataKey: 'nameFr' },
                            { title: t('common.create-date'), dataKey: 'createdAt' },
                        ]}
                        rows={10} 
                        showExport={true}
                        exportFilename="types-prestataires"
                        loading={props.showLoading}
                        lazy={false}
                    />
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        providerTypes: state.provider.providerTypes,
        errorMessage: state.clientAuth.errorMessage,
        successMessage: state.clientAuth.successMessage,
        showLoading: state.provider.showLoading,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(ProviderType);